<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-12">
        <b-field>
          <form-textarea :label="`${$t('interface.description')} *`" v-model="form.description"></form-textarea>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-select :label="`${$t('tasks.taskType')} *`" v-model="form.type">
            <option value="info">{{ $t('workflow.doctypes.info') }}</option>
            <option value="task">{{ $t('workflow.doctypes.task') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-4" v-if="form.type === 'task'">
        <b-field>
          <form-datepicker :label="$t('tasks.term')" :min-date="minDate" v-model="form.term_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-12" v-if="!isEdit">
        <b-field>
          <b-checkbox v-model="form.add_me_as_executor">{{ $t('tasks.addMeAsExecutor') }}</b-checkbox>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary" :disabled="disableForm">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel" :disabled="disableForm">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {prepareDate} from '@/utils'
  import moment from 'moment'

  const defaultTaskData = {
    description: '',
    type: 'task',
    term_date: null,
    add_me_as_executor: false
  }

  export default {
    props: {
      taskData: null,
      editMode: null,
      defaultType: {
        type: String,
        required: false,
        default: 'task'
      }
    },
    data() {
      return {
        form: this.taskData || {
          ...defaultTaskData,
          type: this.defaultType
        },
        isEdit: this.editMode || false,
        errors: [],
        minDate: moment().subtract(1, 'days').toDate(),
        maxDate: new Date(),
        disableForm: false
      }
    },
    methods: {
      validate() {
        let isValid = true
        this.errors = []
        if (this.form.description === '') {
          this.errors.push(this.$t('interface.requiredFields'))
          isValid = false
        } else if (this.form.type === 'task' && this.form.term_date === null) {
          this.errors.push(this.$t('tasks.termError'))
          isValid = false
        }
        return isValid
      },
      save() {
        if (this.validate()) {
          //this.disableForm = true
          this.$emit('save', {
            ...this.form,
            term_date: this.form.term_date ? prepareDate(this.form.term_date) : null
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    computed: {
      ...mapState('Document', ['projects', 'branches', 'detail']),
      ...mapGetters('Document', ['getProjectById'])
    },
    watch: {
      taskData(task) {
        this.form = task
      }
    }
  }
</script>